export const IMAGES_PREFIX = 'images/';

export const FILE_UPLOAD_LIMIT_BYTES = 10 * 1024 * 1024; //10mb
